/**
 * Staff phone on the Team page (T-083). Stored E.164 (+15145550123) — the
 * callback escalation texts and calls it, and the Aircall webhook matches
 * incoming texts against it exactly.
 */
export function toE164(input: string | null | undefined): string | null {
  if (!input) return null;
  const digits = input.replace(/\D/g, '');
  if (!digits) return null;
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
  return `+${digits}`;
}

/** react-admin validator: empty is fine; otherwise a North American number. */
export function validateStaffPhone(value: unknown): string | undefined {
  if (value == null || value === '') return undefined;
  const e164 = toE164(String(value));
  return e164 && /^\+1\d{10}$/.test(e164)
    ? undefined
    : 'Enter a 10-digit phone number, e.g. 514-555-0123';
}

/** (514) 555-0123 */
export function formatStaffPhone(value: string | null | undefined): string {
  const d = (value ?? '').replace(/\D/g, '').replace(/^1(?=\d{10}$)/, '');
  return d.length === 10
    ? `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`
    : value ?? '';
}
